module.exports = __webpack_public_path__ + "img/frame.6fb7a40d.png";